import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../../base/avatar/components/Avatar';
import { translate } from '../../../../base/i18n/functions';
import Icon from '../../../../base/icons/components/Icon';
import { IconCloseLarge } from '../../../../base/icons/svg';
import Label from '../Label';
const useStyles = makeStyles()(theme => {
    return {
        callingDialog: {
            padding: theme.spacing(3),
            textAlign: 'center',
            '& .prejoin-dialog-calling-header': {
                textAlign: 'right'
            },
            '& .prejoin-dialog-calling-label': {
                fontSize: '1rem',
                margin: `${theme.spacing(2)} 0 ${theme.spacing(3)} 0`
            },
            '& .prejoin-dialog-calling-number': {
                fontSize: '1.25rem',
                lineHeight: '1.75rem',
                margin: `${theme.spacing(3)} 0`
            }
        }
    };
});
/**
 * Dialog displayed when the user gets called by the meeting.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactElement}
 */
function CallingDialog(props) {
    const { number, onClose, status, t } = props;
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.callingDialog },
        React.createElement("div", { className: 'prejoin-dialog-calling-header' },
            React.createElement(Icon, { className: 'prejoin-dialog-icon', onClick: onClose, role: 'button', size: 24, src: IconCloseLarge })),
        React.createElement(Label, { className: 'prejoin-dialog-calling-label' }, t(status)),
        React.createElement(Avatar, { size: 72 }),
        React.createElement("div", { className: 'prejoin-dialog-calling-number' }, number)));
}
export default translate(CallingDialog);
